export default {
  velt: {
    openPanel: 'Vula iphaneli yamazwana',
    closePanel: 'Vala iphaneli yamazwana',
    panel: 'Iphaneli yamazwana',
    tabs: 'Amathebhu ephaneli yamazwana',
    comments: 'Amazwana',
    settings: 'Izilungiselelo Nemvume',
    dragOrTapComment: 'Hudula ukuze wengeze umzwana, noma thepha ukuze ubuke amazwana',
    assignComment: 'Yabela umzwana',
    markAsUnread: 'Maka njengokungafundiwe',
    markAsRead: 'Maka njengokufundiwe',
    unsubscribe: 'Khansela ukubhalisa',
    subscribe: 'Bhalisa',
    deleteThread: 'Susa uthredi',
    editComment: 'Hlela umzwana',
    emptyPlaceholder: 'Nikeza impendulo, buza umbuzo noma shiya inothi kumalungu eqembu lakho',
    searchPlaceholder: 'Sesha Amazwana',
    commentPlaceholder: 'Phawula ku-{page}',
    replyPlaceholder: 'Phendula....',
    filterPages: 'Amakhasi',
    filterAuthor: 'Umbhali',
    filterTagged: 'Okuthegiwe',
    statusOpen: 'Kuvuliwe',
    statusResolved: 'Kuxazululiwe',
    anonymous: 'Ongaziwa',
    settingsPanel: {
      title: 'Ubani ongaphawula?',
      everyoneLabel: 'Wonke umuntu',
      restrictedLabel: 'Ababambisene abamenyiwe kuphela',
      emailsLabel: 'Ama-imeyili',
      emailsPlaceholder: 'Engeza i-imeyili bese ucindezela u-enter',
    },
  },
}
